import { pilot } from '~/services/serviceInstances';

export const getCustomAlgorithmChoices = async (): Promise<any> => {
  const response = await pilot.get('client/custom-algorithm-suggestions/');

  return {
    results: response.data,
  };
};
